<ol id="breadcrumbNav" class="breadcrumb-nav">
    <li *ngFor="let breadcrumb of breadcrumbs$; let i = index">
        <a class="cursor-pointer" *ngIf="i != breadcrumbs$?.length - 1" (click)="eventClick(breadcrumb.url)">{{ breadcrumb.label }}</a>
        <span class="breadcrumb-last-li" *ngIf="i == breadcrumbs$?.length - 1">{{ breadcrumb.label }}</span>
    </li>
</ol>